import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-600 font-medium mb-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Field", -1)
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Value", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${_ctx.width} p-3`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "field", {}, () => [
        _hoisted_2
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "value", {}, () => [
        _hoisted_4
      ])
    ])
  ], 2))
}